import React from 'react';
import { CurrentTag } from './CurrentTag';
import { TagData } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Tagging/TagData';

interface CurrentTagsListProps {
  currentTags: TagData[];
  removeTagClick: (value: string) => void;
}

export function CurrentTagsList({ currentTags, removeTagClick }: CurrentTagsListProps) {
  return (
    <ul className="dpc-tags-editor__current-list">
      {currentTags &&
        currentTags.map((tag: TagData, i: number) => (
          <CurrentTag currentTag={tag} removeTagClick={removeTagClick} key={i} />
        ))}
    </ul>
  );
}
